import React, { Component } from 'react';
import { Fstyr } from '../../components/FstyrComponents/Fstyr.js';
import { fetchModel } from '../../components/HelperComponents/FetchExtension';
import { GetStatusName } from '../../components/HelperComponents/StatusHelper';
import { sortCardTableByCreatedDate } from '../../components/HelperComponents/Helpers';
import { DriverCardVm } from '../../Models/DriverCardVm';
import { CheckIssuedCardsVm } from '../../Models/CheckIssuedCardsVm';
import { CprToDateOfBirth } from '../../components/HelperComponents/CprToDateOfBirth.ts'
import { formatAddress } from '../../components/HelperComponents/AddressFormatter'
import { DateFormatter } from '../../components/HelperComponents/DateFormatter.ts'
import { ValidationType } from '../../Constants/ValidationTypes.ts';
import URL from '../../Constants/URL'
import { PersonVm } from '../../Models/PersonVm';

export class SearchCPR extends Component {
  static displayName = SearchCPR.name;

  constructor(props) {
    super(props);
    this.toast = React.createRef();

    this.state = {
      //ButtonPressChecks
      searchButtonPressed: false,

      //Validation
      cprNumberIsValid: false,

      cprInput: "",
      selectedRow: null,

      tableRowIsSelected: false,
      showSpinner: false,

      driverCardVm: [new DriverCardVm()],
      personVm: [new PersonVm()],

      //Search results
      dkSearchResultJson: [],
      euSearchResultJson: [],
      euTableResults: [],
      euAnswers: {
        "Found": 0,
        "NotFound": 0,
        "NotAvailable": 0,
        "TimeOut": 0,
      }
    };
  }

  fetchDriverInfo() {
    this.setState({ searchButtonPressed: true })
    if (this.state.cprNumberIsValid) {
      this.clearPage(false);
      this.setState({ showSpinner: true })
      this.fetchPersonInfo()
      fetchModel("GET", URL + "/api/drivercard/GetDriverCardsByCpr", this.state.cprInput, DriverCardVm)
        .then(model => {
          this.setState({ driverCardVm: model, showSpinner: false })
          this.handleDkSearchResults(model);
          this.setState({ showSpinner: false })
        })
        .catch(error => {
          this.showErrorToast(error, "et førerkort")
          this.setState({ showSpinner: false })
        })
    }

  }

  fetchPersonInfo() {
    fetchModel("GET", URL + "/api/search/GetPerson", this.state.cprInput, PersonVm)
      .then(model => {
        if (model[0].Cpr) {
          this.setState({ personVm: model}, () => {
            this.fetchDriverCardsFromEU(model[0])
          })
        }
      })
      .catch(error => {
        this.setState({ showSpinner: false })
      })
  }

  fetchDriverCardsFromEU(person) {
    this.setState({ showSpinner: true })
    fetchModel("GET", URL + "/api/drivercard/GetDriverCardsFromEuPerson/?firstname=" + person.FirstName +
      "&lastname=" + person.LastName +
      "&birthdate=" + CprToDateOfBirth(person.Cpr), "", CheckIssuedCardsVm)
      .then((model) => {
        if (model) {
          this.handleEuSearchResults(model[0])
        }
        this.setState({ showSpinner: false })
      }).catch(error => {
        this.showErrorToastEU(error)
      })
      .finally(() => { this.setState({ showSpinner: false }) });
  }

  handleDkSearchResults(result) {
    let results = []
      result = sortCardTableByCreatedDate(result)
    for (let i = 0; i < result.length; i++) {
      results.push([
        result[i].CardNumber,
        result[i].Person.DriverLicense.Number,
        DateFormatter(result[i].ValidFrom.split("T")[0]),
        DateFormatter(result[i].ValidTo.split("T")[0]),
        GetStatusName(result[i].Status.Id),
        result[i].Remark
      ])
    }

    this.setState({
      dkSearchResultJson: results
    })
  }

  handleEuSearchResults(result) {
    console.log(result)
    let euAnswers = this.state.euAnswers;
    let results = []

    euAnswers.NotFound = 0
    euAnswers.NotAvailable = 0
    euAnswers.Found = 0
    euAnswers.TimeOut = 0

    for (let i = 0; i < result.MemberStates.length; i++) {
      console.log("Memberstate: ")
      console.log(result.MemberStates[i])

      if (result.MemberStates[i].statusCode === "Found") {
        euAnswers.Found += 1
      }
      else if (result.MemberStates[i].statusCode === "NotFound") {
        euAnswers.NotFound += 1
      }
      else if (result.MemberStates[i].statusCode === "Timeout") {
        euAnswers.TimeOut += 1
      }
      else if (result.MemberStates[i].statusCode === "NotAvailable") {
        euAnswers.NotAvailable += 1
      }

      for (let j = 0; j < result.MemberStates[i].checkIssuedCardResultVm.length; j++) {
        console.log("MemberStates[i].checkIssuedCardResult: ")
        console.log(result.MemberStates[i])
        results.push([
          result.MemberStates[i].checkIssuedCardResult[j].cardNumber,
          result.MemberStates[i].checkIssuedCardResult[j].firstName,
          result.MemberStates[i].checkIssuedCardResult[j].lastName,
          result.MemberStates[i].memberStateCode,
          result.MemberStates[i].checkIssuedCardResult[j].driverLicenseNumber,
          result.MemberStates[i].checkIssuedCardResult[j].cardFromDate.split(" ")[0].replaceAll("/", "-"),
          result.MemberStates[i].checkIssuedCardResult[j].cardToDate.split(" ")[0].replaceAll("/", "-"),
          GetStatusName(result.MemberStates[i].checkIssuedCardResult[j].cardStatus),
        ])
      }

    }

    this.setState({
      euTableResults: results,
      euAnswers: euAnswers
    })
  }

  onRowSelected(row) {
    this.setState({ selectedRow: row })
    if (row === null) {
      this.setState({ tableRowIsSelected: false })
    } else {
      this.setState({ tableRowIsSelected: true })
    }
  }

  clearPage(clearInput) {
    this.setState({

      selectedRow: null,

      tableRowIsSelected: false,
      showSpinner: false,

      driverCardVm: [new DriverCardVm()],
      personVm: [new PersonVm()],

      //Search results
      dkSearchResultJson: [],
      euSearchResultJson: [],
      euTableResults: [],
      euAnswers: {
        "Found": 0,
        "NotFound": 0,
        "NotAvailable": 0,
        "TimeOut": 0,
      }
    })
    if (clearInput) {
      this.setState({
        searchButtonPressed: false,
        cprNumberIsValid: false,
        cprInput: "",
      })
    }
  }

  showErrorToast(error, info) {
    if (error === "No result") {
      this.toast.current.show("Førerkort", "Der findes ikke " + info + " med det søgte CPR nummer", "warning")
    }
    else if (error === "Failed response") {
      this.toast.current.show("Fejl", "Kan ikke forbinde til databasen", "error")
    }

    else {
      this.toast.current.show("Fejl", "Der skete en ukendt fejl", "error")
    }
  }

  showErrorToastEU(error) {
    this.setState({ showSpinner: false })
    if (error === "Failed response") {
      this.toast.current.show("Fejl", "Kan ikke hente data fra EU, prøv at søge igen om lidt.", "warning")
    }
    else {
      this.toast.current.show("EU resultater", "Der er sket en fejl: " + error, "error")
    }
  }

  render() {
    return (
      <div>
        <Fstyr.Toast ref={this.toast} />
        <Fstyr.Segment
          title="Søg Førerkort"
          isPageTitle={true}
        >
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button
              label="Ryd side"
              onClick={() => { this.clearPage(true) }}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Angiv CPR"
        >
          <Fstyr.Input
            value={this.state.cprInput}
            label="CPR nummer"
            direction={"col"}
            onChange={(value) => this.setState({ cprInput: value })}
            validation={true}
            validationType={ValidationType.cpr}
            errorBodyText={"Forkert format (10 tal)"}
            errorExampleText={"f.eks. 1234567890"}
            onEnterPressed={() => this.fetchDriverInfo()}
            setValid={(valid) => this.setState({ cprNumberIsValid: valid })}
            buttonClicked={this.state.searchButtonPressed}
            onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
          />
          <div className="fstyr-left-button-group">
            <Fstyr.Button
              label="Søg"
              onClick={() => this.fetchDriverInfo()}
              disabled={this.state.showSpinner}
            />
            <div style={{ width: 20 }} />
            <Fstyr.Spinner
              show={this.state.showSpinner}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Førerinformation"
        >
          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-12 col-xl-12">
              <div className="fstyr-attention-box">
                <p>Personoplysninger</p>
                <Fstyr.Input
                  label="CPR"
                  readonly={true}
                  value={this.state.personVm[0].Cpr}
                  direction="row"
                />
                <Fstyr.Input
                  label="Fornavn"
                  readonly={true}
                  value={this.state.personVm[0].FirstName}
                  direction="row"
                />
                <Fstyr.Input
                  label="Efternavn"
                  readonly={true}
                  value={this.state.personVm[0].LastName}
                  direction="row"
                />
                <Fstyr.Input
                  label="Adresse"
                  readonly={true}
                  value={formatAddress(this.state.personVm[0].Address, false)}
                  direction="row"
                />
              </div>
            </div>
          </div>
          <div>
            <Fstyr.SelectableTable
              label="Danske resultater"
              headers={["Førerkortnr.", "Kørekortnr.", "Startdato", "Udløbsdato", "Status", "Bemærkning"]}
              data={this.state.dkSearchResultJson === [] ? null : this.state.dkSearchResultJson}
              note={"Ansøger har " + this.state.dkSearchResultJson.length + " registreringer på førerkort"}
              path={"driverCard"}
              tableName="danishResultsTable"
              onRowSelected={(row) => this.onRowSelected(row)}
              useLinks={true}
              disableAll={true}
            />
            <Fstyr.SelectableTable
              label="EU resultater"
              headers={["Førerkortnr.", "Fornavn", "Efternavn", "Land", "Kørekortnr.", "Startdato", "Udløbsdato", "Status"]}
              data={this.state.euTableResults}
              note={"Fundet " + this.state.euTableResults.length + " registreringer på førerkort i EU"}
              tableName="euResultsTable"
              path={"driverCard"}
              onRowSelected={(row) => this.onRowSelected(row)}
              useLinks={false}
              disableAll={true}
            />
            <div className="alert alert-info">
              <div className="alert-body">
                <p className="alert-heading">EU svar</p>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.Found}</p>
                  <p className="alert-text">Found</p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.NotFound}</p>
                  <p className="alert-text">NotFound</p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.NotAvailable}</p>
                  <p className="alert-text">NotAvailable</p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.TimeOut}</p>
                  <p className="alert-text">Timeout</p>
                </div>
              </div>
            </div>
          </div>
        </Fstyr.Segment>
      </div>
    );
  }
}
